import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {EventManagerService} from "../../../core/services/event-manager.service";
import {customSetTimeout} from "../../../core/helpers/overrided-timers";

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss'],
  standalone: true,
  host: {
    '(document:click)': 'onClick($event)',
  }
})
export class CustomDropdownComponent implements OnInit {

  @Input() show : any;
  @Input() menuIndex :any;
  @Input() className : any;
  @ViewChild('element') element: any;
  elementHeight= 0
  constructor(private eventManager: EventManagerService,
              private _eref: ElementRef) { }

  ngOnInit(): void {
    this.show = false
    this.eventManager.menuTrigger.subscribe(data=>{
      customSetTimeout(()=>{
        this.show = (data === this.menuIndex && !this.show);
      })
    })
  }

  hideDropDown():void{
    this.show = false;
    this.element.nativeElement.style.setProperty('display','none');
  }

  onClick($event: any) {
    if (!this._eref.nativeElement.contains($event.target) && this.show){
      customSetTimeout(()=>{
        this.show = false;
        //this.eventManager.menuTrigger.emit(-1);
      },1)
    }

  }
}
